import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import { Col, Row } from 'react-bootstrap';
import Loader from '../Loader/Loader';
import SelectFild from '../SelectFild/SelectFild';
import Autocomplete from '../Autocomplete/Autocomplete';
import { postAddress, postCommonMaster, postlocationDetail } from '../../apiservices/ApiServices';

const Address = (props) => {
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const [pincodeList, setPincodeList] = useState([]);
    const [cityList, setCityList] = useState([]);

    const initialValues = {
        orgId: props.orgId || '',
        id: props.editAddress?.address_id || null,
        countryCode: props.editAddress?.pincodes?.country_id || '',
        pincode: props.editAddress?.pincodes?.pincode || '',
        pincodeId: props.editAddress?.pincodes?.pincode_id || '',
        state: props.editAddress?.pincodes?.state_name || '',
        stateCode: props.editAddress?.pincodes?.state_code || '',
        addressType: props.editAddress?.address_type || '',
        area: props.editAddress?.area || '',
        addressLine1: props.editAddress?.address_line1 || '',
        addressLine2: props.editAddress?.address_line2 || '',
        remarks: props.editAddress?.remarks || '',
        latitude: props.editAddress?.latitude || '',
        longitude: props.editAddress?.longitude || '',
    }

    const { values, errors, touched, handleBlur, setFieldValue, handleChange, handleSubmit } = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);
            let postData = {
                "address_id": values.id,
                "org_id": values.orgId,
                "address_type": values.addressType,
                "address_line1": values.addressLine1,
                "address_line2": values.addressLine2,
                "area": values.area,
                "pincode_id": values.pincodeId,
                "latitude": 28.6139, // optional
                "longitude": 77.2090, // optional
                "remarks": values.remarks
            }
            try {
                const res = await postAddress(postData);
                props.toast.success(res.data.message);
                props.setAddAddress(false)
                setLoadings(false);
                props.postUpdateOrganizationProfiles();

            } catch (error) {
                setLoadings(false);
                props.toast.error(error.response?.data?.message || "Error submitting data");
            }

        }
    })

    const postlocationDetails = async (pincodes) => {
        setLoadings(true);
        let postData = {
            pincode: pincodes,
            country_id: values.countryCode
        }
        try {
            const res = await postlocationDetail(postData);
            setPincodeList(res.data.data);
            console.log(res.data.data)
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            props.toast.error(error.response?.data?.message);
        }
    };

    const postCommonMasters = async () => {
        let postData = {
            type: [
                "country"
            ],
        }
        try {
            const res = await postCommonMaster(postData);
            setCountryList(res.data.data.country);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            props.toast.error(error.response?.data?.message);
        }
    };

    useEffect(() => {
        setLoading(true);
        postCommonMasters();
    }, [])

    return (
        <>
            {isLoading ? <Loader /> :
                <div className='fieldsets cols_5'>
                    <div className='fieldsets-title'>Add Address</div>
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <Row>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Select Country</label>
                                    <SelectFild
                                        Firstop='Select Country'
                                        selectName="countryCode"
                                        options={countryList}
                                        value={values.countryCode}
                                        onChange={(selectedOption) => setFieldValue("countryCode", selectedOption?.value || "")}
                                        onBlur={handleBlur}
                                    />
                                    {errors.countryCode && touched.countryCode && (
                                        <p className="errormsg">{errors.countryCode}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <Autocomplete
                                        name="pincode"
                                        label="pincode"
                                        suggestions={pincodeList || []}
                                        placeholder="Type to search pincode..."
                                        value={values.pincode}
                                        displayField="pincode"
                                        valueField="pincode_id"
                                        onChange={(fieldName, value) => {
                                            if (typeof value === 'object') {
                                                setFieldValue('pincode', value.pincode);
                                                setFieldValue('pincodeId', value.pincode_id);
                                                setFieldValue('state', value.state_name);
                                                setFieldValue('stateCode', value.state_code);
                                                setCityList(value.cities);
                                            } else {
                                                setFieldValue('pincode', '');
                                                setFieldValue('pincodeId', '');
                                                setFieldValue('state', '');
                                                setFieldValue('stateCode', '');
                                                setFieldValue(fieldName, value);
                                                setCityList([]);
                                            }
                                            if (/^\d{0,5}$/.test(value)) {
                                                if (value.length >= 5) {
                                                    postlocationDetails(value);
                                                }

                                            }
                                        }}
                                        onBlur={handleBlur}
                                        error={errors.orgName}
                                        touched={touched.orgName}
                                    />
                                    {errors.orgName && touched.orgName && (
                                        <p className="errormsg">{errors.orgName}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">State</label>
                                    <input
                                        type='text'
                                        id="state"
                                        name="state"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.state}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.state && touched.state && (
                                        <p className="errormsg">{errors.state}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">State Code</label>
                                    <input
                                        type='text'
                                        id="stateCode"
                                        name="stateCode"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.stateCode}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.stateCode && touched.stateCode && (
                                        <p className="errormsg">{errors.stateCode}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">City</label>
                                    <SelectFild
                                        Firstop='Select City'
                                        selectName="pincodeId"
                                        options={cityList}
                                        value={values.pincodeId}
                                        onChange={(selectedOption) => setFieldValue("pincodeId", selectedOption?.value || "")}
                                        onBlur={handleBlur}
                                    />
                                    {errors.pincodeId && touched.pincodeId && (
                                        <p className="errormsg">{errors.pincodeId}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Address Type</label>
                                    <input
                                        type='text'
                                        id="addressType"
                                        name="addressType"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.addressType}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.addressType && touched.addressType && (
                                        <p className="errormsg">{errors.addressType}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">area</label>
                                    <input
                                        type='text'
                                        id="area"
                                        name="area"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.area}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.area && touched.area && (
                                        <p className="errormsg">{errors.area}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Address Line 1</label>
                                    <textarea
                                        type='text'
                                        id="addressLine1"
                                        name="addressLine1"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.addressLine1}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.addressLine1 && touched.addressLine1 && (
                                        <p className="errormsg">{errors.addressLine1}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Address Line 2</label>
                                    <textarea
                                        type='text'
                                        id="addressLine2"
                                        name="addressLine2"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.addressLine2}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.addressLine2 && touched.addressLine2 && (
                                        <p className="errormsg">{errors.addressLine2}</p>
                                    )}
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="form-group">
                                    <label className="form-label">Remarks</label>
                                    <textarea
                                        type='text'
                                        id="remarks"
                                        name="remarks"
                                        className="form-control"
                                        autoComplete='off'
                                        value={values.remarks}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    {errors.remarks && touched.remarks && (
                                        <p className="errormsg">{errors.remarks}</p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                        <div className='modalfooters'>
                            <div className='button-boxs grid'>
                                <button type='submit' className='btn btn-primary'>{props.editAddress?.address_id ? 'Update' : 'Save'}</button>
                                <button type='button' onClick={() => { props.setAddAddress(false); props.setEditAddress(null); }} className='btn btn-default'>Cancel</button>
                            </div>
                        </div>
                    </form>
                </div>
            }
            {isLoadings ? <Loader /> : null}
        </>
    )
}

export default Address
